import { RouterProvider } from "@tanstack/react-router";
import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { validateEnv } from "./configs/validateEnv";
import type { User } from "./features/authenticate/types/user";
import { router } from "./libs/@tanstack/react-router";
import { customizeZodErrorMap } from "./libs/zod/customizeZodErrorMap";
import TagManager from 'react-gtm-module'

validateEnv();
customizeZodErrorMap();


const tagManagerArgs = {
    gtmId: import.meta.env.VITE_GTM_ID
}

TagManager.initialize(tagManagerArgs)


const rootElement = document.getElementById("root");

if (!rootElement) {
	throw new Error("Failed to find the root element");
}

const Root = () => {
	const [user, setUser] = React.useState<User | null>(null);

	const isAuthenticated = React.useMemo(() => {
		return user !== null;
	}, [user]);

	return (
		<StrictMode>
			<RouterProvider
				router={router}
				context={{ auth: { isAuthenticated, user, setUser } }}
			/>
		</StrictMode>
	);
};

createRoot(rootElement).render(<Root />);